(function() {
    'use strict';

    angular
        .module('masterApp')
        .controller('CutOffDialogController', CutOffDialogController);

    CutOffDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'CutOff','$filter','MASTER_CONSTANT'];

    function CutOffDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, CutOff,$filter,MASTER_CONSTANT) {
        var vm = this;
        vm.cutOff = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        
        vm.save = save;
        vm.checkcreat = false;
        vm.lstDate =  MASTER_CONSTANT.dateInMonth;
        if (vm.cutOff.bookClosingId != null || vm.cutOff.bookClosingId != undefined) {
       	 vm.checkcreat = true;
       	vm.cutOff.isExit = true;
       	var time = vm.cutOff.timeClosing.split(/\:|\-/g);
       	$scope.vm.timeClosing = new Date();
       	vm.timeClosing.setHours(time[0]);
       	vm.timeClosing.setMinutes(time[1]);
        }else{
    	   vm.cutOff.isExit = false;
    	   vm.cutOff.status ="0"
    	   $scope.vm.timeClosing = new Date();
    		   
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
        	$scope.clearMessage();
            vm.isSaving = true;
            if (vm.cutOff.isExit == true) {
            	vm.cutOff.timeClosing = $filter('date')(new Date(vm.timeClosing), 'HH:mm');
            	CutOff.update(vm.cutOff,function(result){
          		  $scope.$emit('masterApp:cutOffUpdate', result);
                  $uibModalInstance.close(result);
                  vm.isSaving = false;
        	},function(error) {
        		vm.isSaving = false;
		});
            } else {
            	vm.cutOff.timeClosing = $filter('date')(new Date(vm.timeClosing), 'HH:mm');
            	CutOff.save(vm.cutOff,function(result){
            	 
        		  $scope.$emit('masterApp:cutOffUpdate', result);
                  $uibModalInstance.close(result);
                  vm.isSaving = false;
            	},function(error) {
            		vm.isSaving = false;
    		});
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('masterApp:cutOffUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        };
        vm.openDateClosing = function() {
    		vm.popupDateClosing.opened = true;
    	};
    	$scope.formats = [ 'dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd',
    			'shortDate' ];
    	$scope.format = $scope.formats[2];
    	$scope.altInputFormats = [ 'dd' ];

    	vm.popupDateClosing = {
    		opened : false
    	};

    	vm.dateOptions = {
    		    maxDate: new Date()
    	};
    	
//        $scope.vm.timeClosing = new Date();
  	    $scope.hstep = 1;
  	    $scope.mstep = 15;

  	    $scope.options = {
  	      hstep: [1, 2, 3],
  	      mstep: [1, 5, 10, 15, 25, 30]
  	    };

  	    $scope.ismeridian = false;
  	    $scope.toggleMode = function() {
  	      $scope.ismeridian = ! $scope.ismeridian;
  	    };

  	    $scope.update = function() {
  	      var d = new Date();
  	      d.setHours( 14 );
  	      d.setMinutes( 0 );
  	      $scope.vm.timeClosing = d;
  	    };

  	    $scope.changed = function () {
//  	       $log.log('Time changed to: ' +  $scope.vm.timeClosing);
  	     vm.cutOff.description = 'Thời gian kết sổ tự động => ngày '+vm.cutOff.dateClosing+ ' hàng tháng: lúc' + $filter('date')(new Date(vm.timeClosing), 'HH:mm');
  	    };

  	    $scope.clear = function() {
  	      $scope.vm.timeClosing = null;
  	    };
    }
})();
